module.exports = __webpack_public_path__ + "images/avatars/male/1.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/avatars/male/1.svg
// module id = xD0M
// module chunks = 154